import Version from 'components/Version'
import { AppProject } from 'components/app-project'

const Footer = (): JSX.Element => {
  const date = new Date()
  const year = date.getFullYear()

  return (
    <footer className="pb-4 text-left ml-28">
      <div className="flex items-center gap-2">
        <Version />
        <AppProject />
      </div>
      <p className="font-light tracking-wider text-xs">
        Copyright &copy; 2002-{year} Tranxactor New Zealand Limited. All rights
        reserved.
      </p>
    </footer>
  )
}

export default Footer
